import React, { useEffect } from "react";
import { Grid, Typography } from "@mui/material";
const Timer = ({ resent, seconds, setSeconds, minutes, setMinutes }) => {
  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
    // eslint-disable-next-line
  }, [seconds]);
  return (
    <Grid justifyContent={"center"}>
      <Grid style={{ border: "none", backgroundColor: "transparent" }}>
        {seconds > 0 || minutes > 0 ? (
          <Typography
            sx={{
              fontSize: "12px",
              marginBottom: "12px",
              color: "#000000",
              letterSpacing: "2px",
              fontWeight: "400",
              marginTop: "15px",
              textAlign: "center",
            }}
          >
            Time Remaining :{" "}
            <span style={{ fontWeight: 600 }}>
              {minutes < 10 ? `0${minutes}` : minutes}:
              {seconds < 10 ? `0${seconds}` : seconds}
            </span>
          </Typography>
        ) : (
          <Typography
            sx={{
              fontSize: "12px",
              marginBottom: "12px",
              color: "#000000",
              letterSpacing: "2px",
              fontWeight: "400",
              marginTop: "15px",
              textAlign: "center",
            }}
          >
            {`Haven't received the verification code?`}
            <span
              onClick={resent}
              style={{ color: "#0077FF", cursor: "pointer" }}
            >
              {" "}
              Resend OTP
            </span>
          </Typography>
        )}
      </Grid>
    </Grid>
  );
};

export default Timer;
